module.exports = __webpack_public_path__ + "media/images/service/c_6-da08a9d58417bde89d781c2dd6192444.png";